// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dimple-lowcode-form-configs[data-v-630c06d0]{height:100%;width:100%;overflow:hidden;display:flex;flex-direction:column;padding:0 1.042vw}.tabs[data-v-630c06d0]{border-top:1px solid #ddd}.main[data-v-630c06d0]{flex:1;padding:1.042vw 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
